export default __webpack_public_path__ + "static/media/screen.6d5b90d8.svg";